const al = {
    renewals_title: "Ofertë për ty",
    renewals_offer_step: "Internet Fix",
    renewals_tv_step: "TV",
    renewals_installation_step: "Instalimi",
    renewals_id_step: 'ID',
    renewals_summary_step: "Përmbledhje",
    renewals_bundle_offer: "Ofertë për ty",
    renewals_bundles_subtitle: "Merr dhe përfito më shumë nga ofertat Vodafone!",
    renewals_chosen_plan: "Paketa e zgjedhur",
    renewals_continue_button: "Vazhdo",
    renewals_confirm_button: "Konfirmo",
    renewals_next_button: "Vazhdo në hapin tjetër",
    renewals_choose_plan_button: 'Zgjidh planin',
    renewals_choose_bundle_button: "Zgjidh këtë paketë",
    renewals_without_tv_button: "Vazhdo pa paketa TV",
    renewals_notify_me_button: "Më njofto",
    renewals_cancel_button: "Anullo",
    renewals_location_title: "Vendndodhja",
    renewals_verify_coverage: "Verifiko mbulimin",
    renewals_verify_coverage_desc: "Kemi nevoje për adresën tënde për të verifikuar mbulimin e internetit",
    renewals_view_offer_button: "Zbulo ofertat",
    renewals_view_details_button: "Shiko detajet",
    renewals_get_bundle_button: "Zgjidh këtë paketë",
    renewals_recommended_offer: "Rekomandim për ty",
    renewals_continue_without_tv_button: "Vazhdo pa paketa TV",
    renewals_id_step_title: "Vendos ID tënde",
    renewals_id_step_desc: "Kemi nevoje per të dhëna të sakta nga mjeti yt i identifikimit për të verifikuar identitetin tënd.",
    renewals_id_explaination_text: "Vendos të dhënat e detajuara të mjetit të identifikimit.",
    renewals_take_id: "Foto ID",
    renewals_remove_id: "Foto ID",
    renewals_my_id: "ID ime",
    renewals_offer_valid: 'E vlefshme për %1$s %2$s',
    renewals_combine_offer: 'Kombino %1$s me: ',
    //Bundle
    bundle_choose_plan_button_label: "Zgjidh planin",
    bundle_add_ons_label: "Paketa të tjera",
    bundle_add_ons_extra_label: "Shto paketa të TV",
    bundle_add_ons_button_label: "Shto këtë paketë",

    bundle_characteristic_document_label: 'Kapacitet i lartë dhe qëndrueshmëri',
    bundle_characteristic_upload_label: '%1$s  Mbps shpejtësia e upload',
    bundle_characteristic_download_label: '%1$s Mbps shpejtësia e download',
    bundle_characteristic_fup_label: 'Përdorim pa limit',

    book_appointment_date_step_subtitle: "Zgjidh datën e preferuar për instalimin e pajisjeve",
    book_appointment_date_step_title: "Instalimi",
    renewals_modem_device: "Pajisja modem",
    renewals_modem_device_description: "Zgjidh pajisjen sipas nevojave të tua",
    renewals_installation_fee: "Tarifa e instalimit",
    renewals_installation_fee_description: "Kjo tarifë do t'i shtohet çmimit total",
    renewals_installation_fee_first_time: "Tarife instalimi për instalimin e parë",
    renewals_fee_reallocation_info: "Në qoftë se do të zhvendosësh linjën nuk do të ketë tarifa ekstra",
    renewals_modem_price_info: "* Depozita e pajisjes do të rikthehet kur të ktheni pajisjen mbrapsht",
    renewals_more_info: "Info",
    renewal_close_modal: "Mbyll",
    renewal_processing_action: "Duke proçesuar...",
    renewal_try_again: "Provo përsëri",
    renewal_go_back_button: "Kthehu mbrapa",
    renewal_details_modal_title: "Detaje",
    renewal_modem_deposit: "Depozitë",
    renewal_modem_capacity: "Kapaciteti",
    renewal_modem_deposit_label: "Depozita e modemit",
    renewal_modem_first_time_install: "Instalim për herë të parë",
    renewals_summary_step_title: "Zgjedhja ime",
    renewals_summary_step_desc: "Plani im",
    renewals_summary_step_total_cost: "Kosto totale",
    renewals_summary_step_total_cost_subtitle: "Çfarë do të paguash",
    renewals_monthly: "%1$s në muaj",
    renewals_summary_step_breakdown: "Detaje",
    renewals_summary_step_new_mobile_plan: "Plani yt i ri",
    renewals_summary_step_breakdown_monthly: "Në muaj",
    renewals_summary_step_discount: "Zbritje",
    renewals_summary_step_discount_total_payment: "Totali për t'u paguar",
    renewals_summary_step_first_bill: "Fatura e parë",
    renewals_detail_modal_subtitle: "Pse fatura e radhës është %1$s?",
    renewals_detail_modal_desc: "Fatura e parë mund të jetë e ndryshme nga fatura mujore pasi ndryshimi i planeve është midis muajsh.",
    renewals_detail_modal_monthly_fee: "Tarifa mujore",
    renewals_detail_modal_new_plan_bill: "Fatura e planit të ri",
    renewals_detail_modal_total_cost: "%1$s Lekë",
    renewals_detail_modal_total: 'Total',
    renewals_order_completion_error: "Oops!",
    renewals_order_completion_success: "Kërkesa u dërgua me sukses",
    renewals_order_completion_success_default_desc: "Kërkesa u dergua. Pasi të kryhen verifikimet e duhura ekipi i instalimit do t'ju kontaktojë për të proceduar. Ndërkohe mund të kontrollosh statusin e kërkesës tek Kërkesat e mia.",
    renewals_order_completion_error_default_desc: "Diçka nuk funksionoi",
    //ID step
    renewals_id_personal_number_label: "Numri personal",
    renewals_id_nipt_label: 'NIPT',
    renewals_id_nipt_or_personal_label: 'Numri personal ose NIPT',
    renewals_id_name_label: "Emër",
    renewals_id_surname_label: "Mbiemër",
    renewals_id_identification_type_label: "Lloji i identifikimit",
    renewals_id_issuing_country_label: "Autoriteti lëshues",
    renewals_id_month_label: "Muaji",
    renewals_id_day_label: "Dita",
    renewals_id_year_label: "Viti",
    renewals_expiration_day_label: 'Dita e skadimit',
    renewals_expiration_month_label: "Muaji i skadimit",
    renewals_expiration_year_label: "Viti i skadimit",
    renewals_id_type: 'Lloji i identifikimit',
    renewals_manual_personal_id: 'Numër personal',
    renewals_manual_nipt: 'NIPT',
    renewals_id_wrong_name_format: "Ju lutem shkruani emrin saktë.",
    renewals_id_wrong_surname_format: "Ju lutem shkruani mbiemrin saktë",
    renewals_id_wrong_personal_number_format: "Ju lutem shkruani numrin personal saktë",
    renewals_id_uploaded_photos: "Fotot u ngarkuan",
    //Purchase coverage
    search_input_label: "Kërko adresën",
    notify_me_title: "Më njofto",
    notify_me_subtitle: "Nuk ka mbulim në adresën e kërkuar",
    notify_me_desc: "Vodafone po zgjeron rrjetin dita ditës. Po punojmë që të kemi mbulim në zonën tënde. Do të njoftohesh sapo të kemi përfunduar infrastukturën e nevjoshme për të pasur rrjetin më të mirë.",
    notify_me_cancel_button_label: "Mbyll",

    //camera step
    renewals_camera_front_id: 'Bëni një foto pjesës së përparme të ID-së tuaj',
    renewals_camera_back_id: 'Bëni një foto pjesës së pasme të ID-së tuaj',
    renewals_camera_continue: 'Vazhdo',
    renewals_camera_retake_photo: 'Ribëj foton',
    renewals_camera_selfie: 'Bëni një foto të fytyrës tuaj',

    renewals_camera_permission_denied: 'Aksesi u refuzua',
    renewals_camera_permission_denied_subtitle: 'Ti duhet të japësh akses në kamerën e telefonit për të bërë fotot. Kontrollo konfigurimet e telefonit për të dhënë akses',
    renewals_camera_unavailable: 'Kamera e pa aksesuseshme',
    renewals_camera_unavailable_subtitle: 'Ti nuk mund ta përdorësh funksionaliteit pasi kamera është e pa aksesueshme në pajisjen tënde',
    renewals_camera_go_to_settings: 'Shko tek Konfigurimet',
    renewals_camera_permission_denied_ios_subtitle: 'Ti duhet të japësh akses në kamerën e telefonit për të bërë fotot. Kontrollo konfigurimet e telefonit për të dhënë akses',

    //Summary
    terms_and_conditon_label: "Duke shtypur 'Konfirmo', ju pranoni ",
    link_terms_and_policy_label: 'termat dhe kushtet',
    id_verification_title: 'Verifikimi i ID-së',
    id_verification_close_modal: 'Provo përsëri',
    id_verification_register_new_id: 'Regjistrohu me një ID të re',
    id_verification_modal_title: "Diçka nuk funksionoi!",
    id_verification_modal_desc: 'Verifikimi juaj i ID-së nuk përputhej. Mund të siguroheni që numri personal që po jepni është i saktë?',

    renewal_summary_delivery_section_subtitle: 'Adresa e dërgesës',
    renewals_my_tv: 'Paketa TV',

    renewals_summary_delivery_section_title: 'Dorëzimi',
    renewals_summary_total_cost_error: 'Nuk mund të merrnim çmimin tuaj total për momentin.Ju lutemi provoni përsëri!',
    renewals_installation_modem_note: 'Pajisjet e sugjeruara ofrojnë performancë të lartë në shpjetësitë e ofruara.',
    renewals_installation_free_modem: 'Falas',
    renewals_installation_modem_capacity: 'Maksimal',
    renewals_summary_step_monthly_payment: 'Në muaj',
    renewals_view_details: 'Detajet e përdorimit',
    renewals_terms_title: 'Termat dhe kushtet',
    renewals_id_card_subtitle: 'Verifiko identitietin',
    purchase_customer_verification_error_title: "Diçka nuk funksionoi!",
    purchase_customer_verification_error_message: '"Diçka nuk funksionoi" në verifikimin e numrit tuaj',
    renewals_tv_offer_error: "Nuk mund të ngarkonim ofertat TV për momentin! Ju lutemi provoni përsëri",
    renewals_tv_offer_error_retried: "Nuk mund të ngarkonim ofertat TV për momentin! Ju lutemi provoni përsëri ose vazhdo pa një ofertë TV",
    renewals_tv_resources_info: '* Këto pajisje do te shtohen nga zgjidhja e ofertes TV ',
    Month: 'Muaj',
    Months: 'Muaj',
    renewals_default_error: 'Diçka nuk funksionoi!',
    renewals_no_offers_error: 'Nuk mund të ngarkonim ofertat për momentin!',

    renewals_summary_step_delivery_at: '%1$s në %1$s',

    //url
    purchase_return_policy_url: 'https://api-web-ci-vfal.vodafone.com/file/ReturnPolicy/ReturnPolicyAL.html',
    renewals_return_policy_url: 'https://api-web-ci-vfal.vodafone.com/file/ReturnPolicy/ReturnPolicyAL.html',
    purchase_terms_url: 'https://api-web-ci-vfal.vodafone.com/file/TermsAndCondFIX/TermsAndCondAL.html',
    renewals_terms_url: 'https://api-web-ci-vfal.vodafone.com/file/TermsAndCondFIX/TermsAndCondAL.html',
    purchase_more_info_url: 'https://api-web-ci-vfal.vodafone.com/file/ShikoDetajetPurchase/ShikoDetajetAL.html',
    renewals_more_info_url: 'https://api-web-ci-vfal.vodafone.com/file/ShikoDetajetRenewal/ShikoDetajetAL.html',

    renewals_procesing: 'Duke procesuar',
    go_to_next_step: 'Me dërgo tek hapi tjetër',
    upload: 'Ngarkoni',
    upload_another: 'Ngarkoni foto tjetër',
    no_preview: 'Nuk ka imazh paraprak'
    
}
export default al
